import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'localizedDate',
  pure: false
})
export class NgxDatePipe implements PipeTransform {
 
  constructor( private datePipe: DatePipe) {
  }
 
  public transform(value: any, pattern: string = 'dd. MMMM yyyy'): any {    

  }
}